import {
  CloseButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  MagnifyingGlassIcon,
} from '@cdl/heartbeat-react';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  handleParams,
  setActiveTasksPage,
  setInactiveTasksPage,
} from '../../../actions/admin.actions';
import { debounce } from 'lodash';
import { searchParamsSelector } from '../../../selectors/admin.selectors';

export const GlobalFilter = () => {
  const searchInput = useSelector(searchParamsSelector);
  const [displaySearch, setDisplaySearch] = useState(searchInput);
  const dispatch = useDispatch();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSearchDebounceChange = useCallback(
    debounce((updates: string) => {
      dispatch(handleParams({ param: 'searchInput', value: updates }));
      dispatch(setActiveTasksPage({ page: 1 }));
      dispatch(setInactiveTasksPage({ page: 1 }));
    }, 500),
    [],
  );

  return (
    <>
      <InputGroup w='50%'>
        <InputLeftElement children={<MagnifyingGlassIcon />} />
        <Input
          placeholder='Research by name, annotation grid or users...'
          onChange={(e) => {
            handleSearchDebounceChange(e.target.value);
            setDisplaySearch(e.target.value);
          }}
          value={displaySearch}
        />
        <InputRightElement
          children={<CloseButton />}
          onClick={() => {
            setDisplaySearch('');
            dispatch(handleParams({ param: 'searchInput', value: '' }));
          }}
        />
      </InputGroup>
    </>
  );
};
